const BBAlerts = [
    {
        key: 'GENERIC',
        type: 'error',
        persist: true
    },
    {
        key: 'LOCATION_NOT_FOUND',
        type: 'warning',
        persist: true
    },
    {
        key: 'MISSING_LOCATION',
        type: 'warning',
        persist: true
    },
    {
        key: 'MISSING_POSTCODE',
        type: 'warning',
        persist: true,
    },
    {
        key: 'POSTCODE_INVALID',
        type: 'warning',
        persist: true
    },
    {
        key: 'ITEM_NO_LONGER_AVAILABLE',
        type: 'error',
        persist: true
    },
    {
        key: 'NO_WAITLIST_SPACES_LEFT',
        type: 'error',
        persist: true
    },
    {
        key: 'FORM_INVALID',
        type: 'warning',
        persist: true
    },
    {
        key: 'GEOLOCATION_ERROR_FORBIDDEN',
        type: 'error',
        persist: true
    },
    {
        key: 'GEOLOCATION_ERROR',
        type: 'error',
        persist: true
    },
    {
        key: 'EMPTY_BASKET_FOR_CHECKOUT',
        type: 'warning',
        persist: true
    },
    {
        key: 'MAXIMUM_TICKETS',
        type: 'warning',
        persist: true
    },
    {
        key: 'GIFT_CERTIFICATE_REQUIRED',
        type: 'warning',
        persist: true
    },
    {
        key: 'TIME_SLOT_NOT_SELECTED',
        type: 'warning',
        persist: true
    },
    {
        key: 'STORE_NOT_SELECTED',
        type: 'warning',
        persist: true
    },
    {
        key: 'APPT_AT_SAME_TIME',
        type: 'warning',
        persist: true
    },
    {
        key: 'REQ_TIME_NOT_AVAIL',
        type: 'warning',
        persist: true
    },
    {
        key: 'TOPUP_SUCCESS',
        type: 'success',
        persist: true
    },
    {
        key: 'TOPUP_FAILED',
        type: 'warning',
        persist: true
    },
    {
        key: 'UPDATE_SUCCESS',
        type: 'success',
        persist: true
    },
    {
        key: 'UPDATE_FAILED',
        type: 'warning',
        persist: true
    },
    {
        key: 'ALREADY_REGISTERED',
        type: 'warning',
        persist: true
    },
    {
        key: 'LOGIN_FAILED',
        type: 'warning',
        persist: true
    },
    {
        key: 'SSO_LOGIN_FAILED',
        type: 'warning',
        persist: true
    },
    {
        key: 'PASSWORD_INVALID',
        type: 'warning',
        persist: true
    },
    {
        key: 'PASSWORD_RESET_REQ_SUCCESS',
        type: 'success',
        persist: true
    },
    {
        key: 'PASSWORD_RESET_REQ_FAILED',
        type: 'warning',
        persist: true,
    },
    {
        key: 'PASSWORD_RESET_SUCESS',
        type: 'success',
        persist: true
    },
    {
        key: 'PASSWORD_RESET_FAILED',
        type: 'warning',
        persist: true
    },
    {
        key: 'PASSWORD_MISMATCH',
        type: 'warning',
        persist: true
    },
    {
        key: 'ATTENDEES_CHANGED',
        type: 'info',
        persist: true
    },
    {
        key: 'PAYMENT_FAILED',
        type: 'danger',
        persist: true
    },
    {
        key: 'ACCOUNT_DISABLED',
        type: 'warning',
        persist: true
    },
    {
        key: 'FB_LOGIN_NOT_A_MEMBER',
        type: 'warning',
        persist: true
    },
    {
        key: 'PHONE_NUMBER_IN_USE',
        type: 'warning',
        persist: true
    },
    {
        key: 'EMAIL_IN_USE',
        type: 'warning',
        persist: true
    },
    {
        key: 'WAITLIST_ACCEPTED',
        type: 'success',
        persist: false
    },
    {
        key: 'BOOKING_CANCELLED',
        type: 'success',
        persist: false
    },
    {
        key: 'NOT_BOOKABLE_PERSON',
        type: 'warning',
        persist: false
    },
    {
        key: 'NOT_BOOKABLE_RESOURCE',
        type: 'warning',
        persist: false
    },
    {
        key: 'COUPON_APPLY_FAILED',
        type: 'warning',
        title: '',
        persist: true
    },
    {
        key: 'DEAL_APPLY_FAILED',
        type: 'warning',
        title: '',
        persist: true
    },
    {
        key: 'DEAL_REMOVE_FAILED',
        type: 'warning',
        title: '',
        persist: true
    },
    {
        key: 'SERVICE_HAS_NO_AVAILABILITY',
        type: 'danger',
        persist: true
    },
    {
        key: 'NO_BOOKABLE_EVENTS',
        type: 'danger',
        persist: true
    }
];

angular
    .module('BB')
    .constant('BBAlerts', BBAlerts);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_constants/alerts.constant.js